/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import Item from "components/featured-webpage/common-tasks/webpage-item";
import Config from "data/config";

const CommonTasks = (props) => {
    
    const { values, title, allServices, allServicesPath } = props || {};
    
    return (
        <Fragment>
            <div className="featured-services__wrapper" style={{
                padding: "2.75rem 3.125rem",
                backgroundColor: "#A4C7CF",
                minHeight: "500px",
                width: "100%"
            }}
            >
                <div className="region region-featured-services">
                    <div id="block-views-featured-services-block-1" className="block block-views">
                        
                        <h2 className="block-title">{title}</h2>
                        
                        <div className="content">
                            <div className="view view-featured-services view-id-featured_services view-display-id-block_1 view-dom-id-022a26dc038fe9edad50ca0dd9ec6d0b">
                                <div className="view-content">
                                    
                                    {values &&
                                        values.map((item, index) => {
                                            const { value } = item || {};
                                            // const { style, format, options } = settings || {}
                                            return (
                                                <Fragment key={index}>
                                                    <Item value={value} />
                                                </Fragment>
                                            );
                                        })
                                    }
                                    {allServices &&
                                        <div className="view-footer">
                                            {/*<a href={`${allServicesPath}`}"/programs-and-services/online-payments-and-services">${allServices}All online services</a>*/}
                                            <a href={`${Config.previewUrl}${allServicesPath}`}>{allServices}</a>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};
export default CommonTasks;
